export const fetchNewTeamNotificationStatus = () => {
  return {
    type: "GET_TEAM_NOTIFICATION_STATUS",
  };
};

export const updateNewTeamNotificationStatus = (status) => {
  return {
    type: "UPDATE_TEAM_NOTIFICATION_STATUS",
    data: status,
  };
};

export const addTeamNameToNotification = (name) => {
  return {
    type: "ADD_TEAM_NAME_TO_NOTIFICATION",
    data: name,
  };
};
